import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { LogaltyIframe } from '@/Logalty/ui/organisms'

export const AutoEnrollmentStep4 = (): JSX.Element => {
  const {
    logalty: { logalty },
    nextStep,
  } = useAutoEnrollment()

  return <LogaltyIframe logalty={logalty} callback={nextStep} />
}
